import { Record, Map } from 'immutable';

const ERPDetailsFactory = new Record({
  company_name: '',
});

export const ERPFactory = new Record({
  status: 'disconnected',
  details: ERPDetailsFactory(),
});

function erpItemAdapter({ details, status }) {
  return ERPFactory({
    details: ERPDetailsFactory(details),
    status,
  });
}

export function erpsAdapter(data) {
  return Object.entries(data) // $FlowFixMe
    .reduce((a, v) => a.set(v[0], erpItemAdapter(v[1])), new Map());
}
